import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'
function IQAC() {
  return (
    <>
      <NewMain />
      <Bredcom title="Home" subtitle="IQAC" />
      <section className="about-area about-p pt-120 pb-120 p-relative fix">
        <div className="animations-02">
          <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
        </div>
        <div className="container">
          <div className="row">
            
            <div className="text-column col-lg-12 col-md-12 col-sm-12">
              <div className="about-content s-about-content pl-15 wow fadeInLeft  animated" data-animation="fadeInLeft" data-delay=".4s" >
                 
                <p >
                The Internal Quality Assurance Cell (IQAC) of MVN University serves as a pivotal body dedicated to ensuring and enhancing the quality of education, research, and administration within the institution. In alignment with the guidelines of the University Grants Commission (UGC), India, IQAC is established as a proactive mechanism to institutionalize a culture of quality and continuous improvement. <br/> <br/>
Quality assurance in higher education is a dynamic and ongoing process, and IQAC plays a crucial role in developing strategies for academic excellence, fostering innovation, and promoting best practices. The primary objective of IQAC is to integrate quality-enhancing initiatives into the university’s academic and administrative framework, thereby contributing to the overall institutional growth.<br/> <br/>
IQAC functions as a facilitator rather than a regulator, striving to create and sustain a quality-driven academic environment through participatory approaches involving all stakeholders—faculty, students, administration, alumni, and industry experts. It ensures that the university remains committed to the highest educational standards by consistently monitoring, evaluating, and improving its teaching-learning processes, research activities, governance, and infrastructure.<br/> <br/>
By aligning with national and international accreditation standards, such as NAAC, NBA, and NIRF, IQAC at MVN University aims to promote a culture of excellence, innovation, and inclusivity in higher education. Through regular quality audits, feedback mechanisms, and strategic interventions, the cell ensures that MVN University continues to be a centre of academic distinction, preparing students to excel in a globally competitive environment.
</p>
                <h3>Vision</h3>
                <p>To develop a culture of excellence in higher education by ensuring quality enhancement, innovation, and continuous improvement in academic and administrative processes, thereby fostering holistic development and global competitiveness.</p>

                <h3>Mission</h3>
                <ul className="pr-ul pt-25">
                    <li>  
                      <div className="icon">
                          <i className="fal fa-check" />
                      </div>
                      <div className="text">  To Promote Quality Culture: Establish and nurture a quality culture in all aspects of academic and administrative functions.    </div>
                    </li>

                    <li>  
                      <div className="icon">
                          <i className="fal fa-check" />
                      </div>
                      <div className="text"> 	To Ensure Continuous Improvement: Develop and implement policies and practices for sustained and consistent improvement in institutional performance.   </div>
                    </li>

                    <li>  
                      <div className="icon">
                          <i className="fal fa-check" />
                      </div>
                      <div className="text"> To Enhance Teaching-Learning Practices: Encourage innovative pedagogies, research-oriented learning, and effective student engagement strategies.    </div>
                    </li>

                    <li>  
                      <div className="icon">
                          <i className="fal fa-check" />
                      </div>
                      <div className="text">   	To Strengthen Research and Development: Foster an ecosystem that promotes research, innovation, and industry-academia collaboration.  </div>
                    </li>

                    <li>  
                      <div className="icon">
                          <i className="fal fa-check" />
                      </div>
                      <div className="text">   	To Facilitate Stakeholder Engagement: Ensure active participation of students, faculty, alumni, industry, and society in the quality enhancement process.   </div>
                    </li>

                    <li>  
                      <div className="icon">
                          <i className="fal fa-check" />
                      </div>
                      <div className="text">  	To Implement Best Practices: Adopt and institutionalize best practices for governance, curriculum development, and student support services.   </div>
                    </li>

                    <li>  
                      <div className="icon">
                          <i className="fal fa-check" />
                      </div>
                      <div className="text"> 	To Promote Accreditation and Benchmarking: Align institutional processes with national and international quality benchmarks, including NAAC, NBA, and other accreditation frameworks.   </div>
                    </li>

                    

                   
                   
                </ul>

                <h3>Functions</h3>
                <br/>
                <h5>Quality Planning and Implementation</h5>
                <ul className="pr-ul pt-25" >
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text"> 
                     Develop a comprehensive framework for quality assurance that spans all academic and administrative functions.
                    </div>
                  </li>
                  <li> <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text"> 
                     Plan and execute initiatives to foster continuous improvement in teaching, research, community engagement, and overall institutional governance.</div></li>
                </ul>
                <br/>
                <h5>Monitoring and Evaluation</h5>
                <ul className="pr-ul pt-25" >
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text"> 	Conduct regular reviews and self-assessments of academic and administrative processes.</div>
                  </li>
                  <li><div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text">	Collect, analyze, and monitor data on key performance indicators to ensure alignment with internal benchmarks and external accreditation standards (such as NAAC, NBA, and NIRF).</div>
                  </li>
                  <li><div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text">	Evaluate the effectiveness of implemented strategies and recommend corrective actions wherever necessary.</div>
                  </li>
                 
                </ul> 
                <br/>
                <h5>Feedback Mechanisms and Stakeholder Engagement</h5>
                <ul className="pr-ul pt-25" >
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text"> 	Establish robust mechanisms for gathering feedback from students, faculty, alumni, employers, and other stakeholders. </div>
                  </li>
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text">	Analyze feedback to identify strengths, weaknesses, and areas for potential enhancement.</div>
                  </li>
                  <li><div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text">	Organize consultative meetings, focus groups, and workshops to ensure that all voices contribute to the quality improvement process.</div>
                  </li>
                   
                </ul> 
                <br/>
                <h5>Capacity Building and Professional Development</h5>
                <ul className="pr-ul pt-25" >
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text">	Organize training programs, seminars, and workshops aimed at enhancing the professional skills of faculty and administrative staff.</div>
                  </li>
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text">	Encourage the adoption of innovative teaching-learning methodologies and the integration of research and technology in academic practices.</div>
                  </li>
                  
                </ul>    
                <br/>

                <h5>Documentation and Dissemination of Best Practices </h5>
                <ul className="pr-ul pt-25" >
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text">	Document and archive successful quality improvement practices and initiatives undertaken within the university. </div>
                  </li>
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text">	Share these best practices across various departments to promote a culture of excellence and to inspire further innovation in academic and administrative domains. </div>
                  </li>
                  
                </ul> 
                <br/>
                <h5> Policy Formulation and Strategic Recommendations</h5>
                <ul className="pr-ul pt-25" >
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text"> 	Assist the university leadership in formulating policies and strategies that underpin quality enhancement. </div>
                  </li>
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text"> 	Provide evidence-based recommendations for academic planning, resource allocation, and institutional development. </div>
                  </li>
                  
                </ul> 

                <br/>
                <h5>Accreditation Support and Benchmarking </h5>
                <ul className="pr-ul pt-25" >
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text"> 	Prepare self-study reports and other necessary documentation to support the university’s accreditation processes. </div>
                  </li>
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text">	Continuously benchmark institutional performance against national and international standards, ensuring that MVN University remains at the forefront of educational excellence. </div>
                  </li>
                  
                </ul> 
                <br/>

                <h5>Continuous Quality Improvement </h5>
                <ul className="pr-ul pt-25" >
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text"> 	Initiate corrective measures based on periodic evaluations and emerging trends in higher education. </div>
                  </li>
                  <li>
                    <div className="icon">
                        <i className="fal fa-check" />
                    </div>
                    <div className="text"> 	Foster a proactive environment where continuous self-improvement is embedded in the institutional culture. </div>
                  </li>
                  
                </ul> 


                <br/>

                <h3>Objectives</h3>
                <p>The <strong> Internal Quality Assurance Cell (IQAC) </strong> at  <strong>MVN University </strong> is established with the primary goal of ensuring continuous quality enhancement in all academic and administrative functions. The objectives of IQAC, aligned with UGC and NAAC guidelines, are as follows:</p>

                <h5>To Develop a Quality Culture</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Foster a culture of excellence, innovation, and continuous improvement in all aspects of the university.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Encourage accountability and transparency in academic and administrative processes.
    </div>
  </li>
</ul>
<br/>
<h5>To Promote Academic Excellence</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Enhance the effectiveness of the teaching-learning process by adopting innovative pedagogies and technology-driven methodologies.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Facilitate faculty development programs, workshops, and training sessions to improve teaching and research competencies.
    </div>
  </li>
</ul>
<br/>
<h5>To Ensure Student-Centric Learning</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Strengthen student support services, academic counseling, and mentoring to enhance learning outcomes.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Implement feedback mechanisms to assess and improve student satisfaction and performance.
    </div>
  </li>
</ul>
<br/>
<h5>To Strengthen Research and Innovation</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Encourage research, publications, patents, and collaborations with industries and research institutions.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Facilitate funding opportunities for research projects and promote an interdisciplinary approach to innovation.
    </div>
  </li>
</ul>
<br/>
<h5>To Improve Infrastructure and Learning Resources</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Ensure the availability of state-of-the-art infrastructure, modern laboratories, libraries, and digital learning platforms.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Promote the integration of ICT (Information and Communication Technology) in academic and administrative activities.
    </div>
  </li>
</ul>
<br/>
<h5>To Establish Robust Feedback and Evaluation Mechanisms</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Develop structured feedback systems from students, faculty, alumni, employers, and other stakeholders for continuous assessment and improvement.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Utilize feedback analysis to refine curricula, teaching methods, and institutional policies.
    </div>
  </li>
</ul>
<br/>
<h5>To Facilitate Accreditation and Quality Benchmarking</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Align with national and international accreditation frameworks (NAAC, NBA, NIRF, ARIIA, etc.) to ensure adherence to quality standards.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Regularly assess and benchmark university performance against peer institutions.
    </div>
  </li>
</ul>
<br/>
<h5>To Strengthen Industry-Academia Linkages</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Promote industry collaborations, internships, and skill-development programs to enhance employability and entrepreneurship.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Organize guest lectures, industry visits, and knowledge-sharing sessions with professionals.
    </div>
  </li>
</ul>
<br/>
<h5>To Institutionalize Best Practices and Good Governance</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Develop and document best practices for efficient governance, administration, and academic delivery.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Ensure ethical standards, inclusivity, and sustainability in all university operations.
    </div>
  </li>
</ul>
<br/>
<h5>To Enhance Community Engagement and Social Responsibility</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Encourage extension activities, outreach programs, and community service to inspire social responsibility among students and faculty.
    </div>
  </li>
  <li>
    <div className="icon">
      <i className="fal fa-check" />
    </div>
    <div className="text">
       Promote environmental sustainability through green initiatives and eco-friendly campus practices.
    </div>
  </li>
</ul>


                
<br/>

<h3>Composition</h3>
<div class="containe_tedxt"> 
<table border="1" cellspacing="0" cellpadding="8">
  <thead>
    <tr>
      <th>S. No.</th>
      <th>Name</th>
      <th>Designation</th>
      <th>Role in IQAC</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Prof. (Dr.) Arun Garg</td>
      <td>Vice-Chancellor</td>
      <td>Chairman</td>
    </tr>
    <tr>
      <td>2</td>
      <td>Prof. (Dr.) Yogendra Singh</td>
      <td>Registrar & Director IQAC</td>
      <td>Vice-Chairman</td>
    </tr>
    <tr>
      <td>3</td>
      <td>Mr. J. P. Gaur</td>
      <td>Member, Board of Management</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>4</td>
      <td>Prof. (Dr.) N. P. Singh</td>
      <td>Pro Vice Chancellor & Dean</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>5</td>
      <td>Dr. Kuldeep Tanwar</td>
      <td>Controller of Examination & Dean</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>6</td>
      <td>Dr. Rahul Varshney</td>
      <td>Professor & Dean</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>7</td>
      <td>Dr. Ashutosh Upadhayay</td>
      <td>Professor & Dean</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>8</td>
      <td>Dr. Vineet Kumar</td>
      <td>Professor & Dean</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>9</td>
      <td>Mr. Daya Shankar Prasad</td>
      <td>Assistant Professor & Head</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>10</td>
      <td>Dr. Amit Sagu</td>
      <td>Assistant Professor</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>11</td>
      <td>Dr. Nakul Gupta</td>
      <td>Associate Professor, MDI Gurugram (External)</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>12</td>
      <td>Sourya Foundation</td>
      <td>NGO</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>13</td>
      <td>Ms. Megha (MBA, 23MS5008)</td>
      <td>Student Representative</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>14</td>
      <td>Mr. Rakesh Sharma</td>
      <td>Developer, Onetick Technology Pvt. Ltd.</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>15</td>
      <td>Mr. Sanjeev Bansal</td>
      <td>Assistant Registrar</td>
      <td>Member</td>
    </tr>
    <tr>
      <td>16</td>
      <td>Dr. Shrivardhan Dheeman</td>
      <td>Deputy Director IQAC</td>
      <td>Member Secretary</td>
    </tr>
  </tbody>
</table>
 
</div>

<br/>
<h3>Strategies</h3> 

<h5>Formation and Strengthening of IQAC</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Define roles and responsibilities for NAAC accreditation preparation.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Conduct periodic IQAC meetings to review progress.</div>
  </li>
</ul>
<br/>
<h5>Awareness and Capacity Building</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Organize workshops, seminars, and orientation programs on accreditation criteria, quality benchmarks, and best practices.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Conduct training programs for faculty and staff on data documentation and evidence collection.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Develop a culture of quality enhancement through regular discussions and sensitization.</div>
  </li>
</ul>
<br/>
<h5>Gap Analysis and SWOT Assessment</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Perform a self-assessment based on NAAC guidelines.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Identify strengths, weaknesses, opportunities, and threats (SWOT) in academic and administrative processes.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Develop a roadmap to address gaps.</div>
  </li>
</ul>
<br/>
<h5>Documentation and Data Management</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Establish a centralized data repository for institutional records.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Ensure systematic documentation of academic activities, faculty profiles, student achievements, and administrative reports.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Maintain records of feedback, alumni engagement, research contributions, and extension activities.</div>
  </li>
</ul>
<br/>
<h5>Curriculum Development and Teaching-Learning Enhancement</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Implement outcome-based education (OBE) and innovative teaching methodologies.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Strengthen ICT-enabled learning, blended learning, and MOOCs integration.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Conduct periodic curriculum reviews in alignment with industry and societal needs.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Promote faculty development programs to enhance pedagogical skills.</div>
  </li>
</ul>
<br/>
<h5>Student Support and Progression</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Strengthen mentoring and counselling systems for academic and personal support.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Improve placement and career guidance initiatives.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Establish mechanisms for tracking alumni and student progression.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Enhance student participation in co-curricular and extracurricular activities.</div>
  </li>
</ul>
<br/>
<h5>Research, Innovation, and Extension</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Encourage faculty to undertake research projects and publish in indexed journals.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Strengthen collaborations with industry, academia, and research institutions.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Promote patent filing and technology transfer initiatives.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Enhance community engagement through extension and outreach programs.</div>
  </li>
</ul>
<br/>
<h5>Governance and Institutional Social Responsibility</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Strengthen participatory governance with transparency and accountability.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Implement best practices for sustainable development and green initiatives.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Enhance social responsibility through community-driven projects.</div>
  </li>
</ul>
<br/>
<h5>Quality Audits and Continuous Improvement</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Conduct periodic academic and administrative audits.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Implement feedback mechanisms for continuous assessment from stakeholders.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Develop an action plan based on audit recommendations.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Institutionalize best practices for continuous improvement.</div>
  </li>
</ul>
<br/>
<h5>Preparation for NAAC Accreditation Process</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Ensure compliance with NAAC eligibility criteria.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Prepare and submit the Institutional Information for Quality Assessment (IIQA).</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Compile Self-Study Report (SSR) with supporting documents and evidence.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Prepare for Student Satisfaction Survey (SSS) and Data Validation & Verification (DVV) process.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Conduct mock visits and prepare for the NAAC Peer Team Visit.</div>
  </li>
</ul>

<h5>Post-Accreditation Quality Sustenance</h5>
<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Develop an institutional post-accreditation action plan.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Strengthen quality initiatives for continuous improvement and re-accreditation preparedness.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Regularly update the institutional website with quality-related reports and achievements.</div>
  </li>
</ul>





<br/>

<h3>Mechanism</h3> 

<ul className="pr-ul pt-25">
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Ensuring timely, efficient, and progressive performance of academic, administrative, and financial tasks.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Optimization and integration of modern methods of teaching and learning.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Relevant and quality academic/ research programs.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> The credibility of assessment and evaluation process.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Equitable access to and affordability of academic programs for various sections of society.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Ensuring the adequacy, maintenance, and proper allocation of the support structure and services.</div>
  </li>
  <li>
    <div className="icon"><i className="fal fa-check" /></div>
    <div className="text"> Sharing of research findings and networking with other institutions in India and abroad.</div>
  </li>
</ul>

<br/>
<h3>Nine Goals</h3> 

<ul>
  <li><strong>Goal 1:</strong> A productive workplace with clear expectations and a commitment to excellence, as well as an ecosystem.</li>
  <li><strong>Goal 2:</strong> Recognizing ability in the context of equity issues for potential students.</li>
  <li><strong>Goal 3:</strong> A learning atmosphere that gives students the best chance of succeeding.</li>
  <li><strong>Goal 4:</strong> Research with high possible impact and the nation’s economic development.</li>
  <li><strong>Goal 5:</strong> Strong relationships with partners.</li>
  <li><strong>Goal 6:</strong> High-quality infrastructure to enable teaching-learning, research, and community engagement.</li>
  <li><strong>Goal 7:</strong> Governance and management practices that are in accordance with the mission and values of the university.</li>
  <li><strong>Goal 8:</strong> Sustainable practices for more effective resource usage and improved environmental performance.</li>
  <li><strong>Goal 9:</strong> A growth path to support the university activities.</li>
</ul>


<br/>
<h3>Benefits</h3> 
<p>The Internal Quality Assurance Cell (IQAC) plays a crucial role in enhancing the overall quality and growth of a university. It ensures continuous improvement in academic and administrative performance through systematic planning, evaluation, and execution of quality initiatives. By fostering a culture of excellence, IQAC helps in accreditation, curriculum enhancement, and research promotion. <br/> <br/>
IQAC encourages faculty development, student-centric learning, and the adoption of innovative teaching methodologies. It also facilitates industry collaborations, skill-based training, and employability programs, thereby improving graduate outcomes. Regular audits, feedback mechanisms, and benchmarking against global standards ensure the institution’s sustained progress. <br/> <br/>
Furthermore, IQAC promotes inclusivity, transparency, and governance efficiency. It aids in policy formulation, resource optimization, and infrastructure development. Through workshops, seminars, and awareness programs, it inspires a quality-conscious mindset among stakeholders.
By aligning university goals with national and international quality standards, IQAC enhances institutional credibility, rankings, and overall reputation. Its continuous monitoring and evaluation contribute significantly to academic excellence, making the university a centre of innovation, research, and holistic education.
 </p>



              </div>
            </div>
            <div className="info-column col-lg-4 col-md-12 col-sm-12" style={{display: "none"}}>
                <div className="inner-column2">                    
                    <ul className="project-info ">                        
                        <li>
                            <div className="slider-btn">
                                <Link to="/compositionofiqac" className="btn ss-btn smoth-scroll">
                                    Composition of IQAC <i className="fal fa-long-arrow-right" />
                                </Link>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default IQAC